import React from 'react';

const AIChatbot = ({ showChatbot, setShowChatbot }) => {
  if (!showChatbot) return null;
  return (
    <div className="fixed bottom-36 right-2 w-80 h-96 bg-gray-800 rounded-lg shadow-xl z-50 flex flex-col">
      <div className="bg-primary text-white p-4 rounded-t-lg flex justify-between items-center">
        <h3 className="font-semibold">Assistant IA 2RENOV</h3>
        <button 
          onClick={() => setShowChatbot(false)}
          className="text-white hover:bg-primary/80 rounded p-1"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div className="flex-1 p-4 bg-gray-700 overflow-y-auto">
        <div className="bg-gray-600 rounded-lg p-3 mb-3">
          <p className="text-white text-sm">
            Bonjour ! Je suis votre assistant IA. Comment puis-je vous aider avec votre projet de rénovation ?
          </p>
        </div>
        <div className="text-center text-gray-400 text-sm">
          Fonctionnalité à venir...
        </div>
      </div>
      <div className="p-4 bg-gray-800 rounded-b-lg">
        <div className="flex">
          <input 
            type="text" 
            placeholder="Tapez votre message..."
            className="flex-1 bg-gray-700 text-white rounded-l-lg px-3 py-2 text-sm focus:outline-none"
            disabled
          />
          <button className="bg-primary text-white px-4 py-2 rounded-r-lg">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AIChatbot;
